import React from "react";
import AdminHeader from "../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../components/admin/AdminFooter";
import AdminTemplatesPageAdd from "../../../views/admin/template/add";

const AdminTemplatePage = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
      <AdminTemplatesPageAdd />
      <AdminFooter />
    </div>
  );
};

export default AdminTemplatePage;
